import React from 'react';
import { Button, Table } from 'antd';
import moment from 'moment';

function renderStatus(status) {
    const map = {
        draft: { className: 'order-status-badge order-status-badge--draft', label: 'Draft' },
        confirmed: { className: 'order-status-badge order-status-badge--confirmed', label: 'Confirmed' },
        cancelled: { className: 'order-status-badge order-status-badge--cancelled', label: 'Cancelled' }
    };
    const meta = map[status] || { className: 'order-status-badge order-status-badge--default', label: status || 'Unknown' };
    return <span className={meta.className}>{meta.label}</span>;
}

export default function OrderListTable(props) {
    const { data = [], loading, page, limit, total, onPageChange, onOpenDetail, onClaimOrder } = props;

    const columns = [
        {
            title: 'Mã đơn',
            key: 'order_code',
            render: (_, item) => (
                <div className="order-list-table__primary-cell">
                    <div className="order-list-table__code">{item.order_code || '—'}</div>
                </div>
            )
        },
        {
            title: 'Khách hàng',
            key: 'customer_name',
            render: (_, item) => (
                <div className="order-list-table__stack">
                    <div className="order-list-table__primary">{item.customer ? item.customer.name : '—'}</div>
                    <div className="order-list-table__secondary">{item.customer ? item.customer.phone : '—'}</div>
                </div>
            )
        },
        {
            title: 'Source',
            key: 'source',
            render: (_, item) => <span className="order-list-table__secondary">{item.source ? item.source.channel_type || '—' : '—'}</span>
        },
        {
            title: 'Người xử lý',
            key: 'assignee',
            render: (_, item) => (
                <div className="order-list-table__stack">
                    <div className="order-list-table__primary">{item.assignee && item.assignee.name ? item.assignee.name : 'Chưa assign'}</div>
                    <div className="order-list-table__secondary">{item.assignee && item.assignee.name ? 'Đang phụ trách' : 'Có thể nhận xử lý'}</div>
                </div>
            )
        },
        {
            title: 'Tổng tiền',
            key: 'total',
            align: 'right',
            render: (_, item) => (
                <span className="order-list-table__amount">{`${new Intl.NumberFormat('vi-VN').format(item.pricing ? item.pricing.grand_total || 0 : 0)}đ`}</span>
            )
        },
        { title: 'Trạng thái', key: 'status', render: (_, item) => renderStatus(item.status) },
        {
            title: 'Cập nhật',
            key: 'updated_time',
            render: (_, item) => (
                <span className="order-list-table__secondary">{item.updated_time ? moment(item.updated_time).format('HH:mm DD-MM-YYYY') : '—'}</span>
            )
        },
        {
            title: 'Thao tác',
            key: 'actions',
            render: (_, item) => (
                <div className="order-list-table__actions">
                    <Button className="order-list-table__action order-list-table__action--primary" size="small" type="primary" onClick={() => onOpenDetail(item)}>Chi tiết</Button>
                    {item.permission_flags && item.permission_flags.can_assign ? (
                        <Button className="order-list-table__action" size="small" onClick={() => onClaimOrder(item)}>Nhận xử lý</Button>
                    ) : null}
                </div>
            )
        }
    ];

    return (
        <div className="order-list-table">
            <div className="order-list-table__surface">
                <Table
                    rowKey="_id"
                    loading={loading}
                    columns={columns}
                    dataSource={data}
                    className="order-list-table__antd"
                    locale={{
                        emptyText: <div className="order-list-table__empty">Chưa có đơn hàng phù hợp với bộ lọc hiện tại</div>
                    }}
                    pagination={{
                        current: page,
                        pageSize: limit,
                        total,
                        onChange: onPageChange,
                        showSizeChanger: true,
                        onShowSizeChange: onPageChange,
                        className: 'order-list-table__pagination'
                    }}
                />
            </div>
        </div>
    );
}
